import "./Timer.css";
import { useEffect, useState } from "react";
import { Modal, Button, Toast, ToastContainer } from "react-bootstrap";

const Timer = ({
  defaultSeconds, 
  isActive, 
  showSuccess, 
  setCloseSuccess, 
  guessCount, 
  hurrydleRows,
}) => {
  const [seconds, setSeconds] = useState(defaultSeconds | 0);
  // Speedle Toast
  const [showToast, setShowToast] = useState(false);
  
  function shareAndClose() {
    const myCopiedText = "⚡ " + seconds + " seconds ⚡ and ❓ " + guessCount + " guesses ❓"
      + " with a" + ((seconds * guessCount) === 0 ? " PERFECT" : "") +" Speedle score => " + (seconds * guessCount) + " for my daily word on speedle.paulpeters.me";
    navigator.clipboard
      .writeText(myCopiedText)
      .then(() => {
        setCloseSuccess();
        setShowToast(true);
      });
  }

  useEffect(() => {
    let interval = null;
    if (isActive) {
      interval = setInterval(() => {
        setSeconds(seconds => seconds + 1);
      }, 1000);
    } else if (!isActive && seconds !== 0) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  const myScore = guessCount * seconds;
  return (
    <div className="App-timer">
      <div className="App-timer-text">
        <div className="time-help" hidden={guessCount === 0 && seconds === 0 ? "" : true }>
          guess to start your journey <span className="time-green">time and guesses factor into your score</span>
        </div>
        <div hidden={isActive && seconds > 0 ? "" : true } className={seconds < 50 ? "time-green" : (seconds > 100 ? "time-red" : "time-yellow")}>
          <b>{seconds}</b> seconds
        </div>
        <div hidden={!isActive && guessCount > 0 ? "" : true } className={myScore < 100 ? "time-green" : (myScore > 500 ? "time-red" : "time-yellow")}>
          Your score was {myScore === 0 ? "a PERFECT " : ""}<b>{myScore}</b> <Button variant="success" size="sm" onClick={shareAndClose}>SHARE 💌</Button>
        </div>
        <p hidden={!isActive && seconds > 0 ? "" : "hidden" }>
          Come back tomorrow for a new <span className="speedle-font"><span className="time-green">speed</span><span className="time-yellow">l</span><span className="time-red">e</span></span>
        </p>
      </div>
      <MySuccessModal
        show={showSuccess}
        closeSuccess={setCloseSuccess}
        shareAndClose={() => shareAndClose()}
        seconds={ seconds }
        guessCount={ guessCount }
        hurrydleRows={ hurrydleRows }
      />
      <ToastContainer className="p-3" position={"middle-center"}>
        <Toast 
          onClose={() => setShowToast(false)} 
          show={showToast} 
          delay={3000} 
          autohide
          className="speedle-toast"
        >
          <Toast.Body>
            👍 <strong>Results copied to clipboard</strong>
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default Timer;

function MySuccessModal({show, closeSuccess, shareAndClose, seconds, guessCount, hurrydleRows}) {
  const myScore = guessCount * seconds;

  if (guessCount > 0 && show) {
    // Update local storage now that the game has been completed
    const todayString = localStorage.getItem("today");
    let updateToday = false;
    let todayJson = {};

    // Date setup 
    let myDate = new Date();
    const myStringDate = myDate.getDate() + "-" + (myDate.getMonth() + 1) + "-" + myDate.getFullYear();
    if (todayString === undefined || todayString === null) {
      updateToday = true;
    } else {
      todayJson = JSON.parse(todayString);
      // Check if today is actually today and update if it isn't
      if (todayJson.date !== myStringDate) {
        updateToday = true;
      }
    }

    // Update today if required
    if (updateToday) {
      // Setup today with proper format and today's date
      todayJson = {
        date: myStringDate,
        guessCount: guessCount,
        seconds: seconds,
        hurrydleRows: hurrydleRows
      };
      // Save today's stats
      localStorage.setItem("today", JSON.stringify(todayJson));

      // Now update user stats
      const statsString = localStorage.getItem("myStats");
      let statsJson = [];
      if (statsString === undefined || statsString === null) {
        // Initialize the stat data
        statsJson = [todayJson];
      } else {
        statsJson = JSON.parse(statsString);
        // Add onto this stats array
        statsJson.push(todayJson);
      }

      // Save today's stats
      localStorage.setItem("myStats", JSON.stringify(statsJson));
    }
  }

  return (
    <Modal
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton onHide={closeSuccess} className="modal-share">
        <Modal.Title>
        🎉 Your journey is complete 🎉
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-share">
        <p className={seconds < 50 ? "time-green" : (seconds > 100 ? "time-red" : "time-yellow")}>
          <b>{seconds}</b> seconds
        </p>
        <p className={guessCount < 5 ? "time-green" : (guessCount > 10 ? "time-red" : "time-yellow")}>
          <b>{guessCount}</b> guesses
        </p>
        <p className={myScore < 100 ? "time-green" : (myScore > 500 ? "time-red" : "time-yellow")}>
          Your score was <b>{myScore}</b>
        </p>
        <h4 hidden={myScore === 0 ? "" : "hidden"}>
          A perfectly perfect score.
        </h4>
        <h4 hidden={(myScore > 0 && myScore < 100) ? "" : "hidden"}>
          Talk about efficiency!!!
        </h4>
        <h4 hidden={myScore > 100 && myScore < 500 ? "" : "hidden"}>
          You're moving up in the world!
        </h4>
        <h4 hidden={myScore > 500 ? "" : "hidden"}>
          Not bad, that was a tough one.
        </h4>
        <br/>
        <Button variant="success" onClick={shareAndClose}>SHARE 💌</Button>
      </Modal.Body>
    </Modal>
  );
}